import styled from "styled-components";

export const Circle = styled.div`
  transform: scale(1);
  position: relative;
  height: 100px;
  width: 100px;

  @-webkit-keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
  /* @-webkit-keyframes color {
    0% {
      stroke:white;
    }
    40% {
      stroke:white;
    }
    66% {
      stroke:white;
    }
    80%,
    90% {
      stroke:white;
    }
  }
  @keyframes color {
    0% {
      stroke:white;
    }
    40% {
      stroke:white;
    }
    66% {
      stroke:white;
    }
    80%,
    90% {
      stroke:white;
    }
  } */
`;

export const LoaderPath = styled.circle`
  stroke-dasharray: 150, 200;
  stroke-dashoffset: -10;
  -webkit-animation:
    dash 1.5s ease-in-out infinite,
    color 6s ease-in-out infinite;
  animation:
    dash 1.5s ease-in-out infinite,
    color 6s ease-in-out infinite;
  stroke-linecap: round;
  strokewidth: 3px;
  fill: none;
  stroke: ${({ theme }) => theme.colors.neutral.white};
`;

export const SecondLoaderPath = styled.circle`
  strokewidth: 3px;
  fill: none;
  stroke: ${({ theme }) => theme.colors.primary.cetaceanBlue};
`;

export const CircularLoader = styled.svg`
  -webkit-animation: rotate 2s linear infinite;
  animation: rotate 2s linear infinite;

  -webkit-transform-origin: center center;
  -ms-transform-origin: center center;
  transform-origin: center center;

  top: 0;
  left: 0;
  margin: auto;
`;

export const CircularBackground = styled.svg`
  position: absolute;
  left: 0;
  z-index: -1;
`;
